var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWbtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.1 22.94l-3 3c14.838 16.226 14.838 41.094 0 57.32l3 3c16.513-17.904 16.513-45.486 0-63.39v.07zM26 23.2c16.226-14.838 41.094-14.838 57.32 0l3-3c-17.904-16.513-45.486-16.513-63.39 0l3.07 3zM23.2 83.29C8.38 67.068 8.38 42.222 23.2 26l-3-3c-16.513 17.904-16.513 45.486 0 63.39l3-3.1zM83.29 86.06c-16.226 14.838-41.094 14.838-57.32 0l-3 3c17.904 16.513 45.486 16.513 63.39 0l-3.07-3z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58 44.63c-.6-6.26-6-8.36-12.83-9V27h-5.28v8.46c-1.39 0-2.81 0-4.22.05V27H46v8.68H35.3v5.65s3.9-.07 3.84 0a2.73 2.73 0 013 2.32v23.77a1.87 1.87 0 01-2 1.75c.07.06-3.84 0-3.84 0l-1.05 6.31h10.66v8.82h5.28v-8.69h4.22v8.65h5.29v-8.72c8.92-.54 15.14-2.74 15.92-11.09.63-6.72-2.53-9.72-7.58-10.93 3.07-1.56 5-4.31 4.54-8.89zm-7.4 18.78c0 6.56-11.24 5.81-14.82 5.81V57.58c3.58.01 14.82-1.02 14.82 5.83zM63.73 47c0 6-9.38 5.27-12.36 5.27V41.7c2.98 0 12.36-.94 12.36 5.3z",
    fill: "#F09242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.63 109.27C24.461 109.264.008 84.805.01 54.637.012 24.468 24.468.012 54.637.01c30.168-.002 54.627 24.451 54.633 54.62-.033 30.163-24.477 54.607-54.64 54.64zm0-105C26.835 4.287 4.313 26.828 4.32 54.623c.007 27.796 22.541 50.325 50.337 50.327 27.795.002 50.332-22.524 50.343-50.32-.033-27.798-22.572-50.319-50.37-50.33v-.03z",
    fill: "#282138"
  }))));
}

export default __webpack_public_path__ + "static/media/wbtc.83a8a9c84a532e5571a90d5d2e526ee7.svg";
export { SvgWbtc as ReactComponent };